<template>
  <td class="table-cell" :class="col.additionalCellClasses">
    <component
      :is="col.cellComponent"
      v-bind.sync="row[col.property]"
      v-if="col.cellComponent"
    />
    <actions-cell
      :object="row"
      :actions="col.actions"
      v-else-if="col.property === 'actions'"
    />
    <template v-else>
      <div v-if="col.property === 'address'">
        <p>{{ row.address.address_1 }}</p>
        <p>{{ row.address.cityStateZip }}</p>
      </div>
      <div v-else-if="col.property === 'places'">
        <div
          class="pb-1"
          v-for="place in row[col.property]"
          :key="`${place.address_1}-${place.cityStateZip}`"
        >
          <p>{{ place.address_1 }}</p>
          <p>{{ place.cityStateZip }}</p>
        </div>
      </div>
      <div v-else-if="Array.isArray(col.property)">
        <div :key="`prop_${i}`" v-for="(prop, i) in col.property">
          {{ row[prop] }}
        </div>
      </div>
      <span v-else>{{ row[col.property] }}</span>
    </template>
  </td>
</template>

<script>
import ActionsCell from "./special-cells/ActionsCell";

export default {
  name: "TableCell",
  components: { ActionsCell },
  props: {
    row: Object,
    col: Object
  }
};
</script>

<style scoped></style>
